import '../../public/fonts/stylesheet.css'
import '../index.css'
import '../reset.css'
// TODO: по какой-то причине стили для тултипа из ui-kit
// не попадают в билд из коробки.
// Вероятно нужны допилы в настройки билда некста, пока не разобрался
import 'tippy.js/index.css'
import '@application/styles/supportChatStyles'
import App from '@application/App'

export default App
